import Container from '@/components/container'
import AppContent from '@/components/content'
import DefinitionLoader from '@/components/content/definitionLoader'
import Searcher from '@/components/content/searcher'
import { router } from '@/router'

export default {
  methods: {
    getDefaultCurrentContent (menu) {
      var currentContent = null
      menu.map((item) => {
        var defaultFound = false
        if (item.default) {
          currentContent = item
          defaultFound = true
        }
        if (defaultFound && item.subMenu) {
          var childCurrentContent = this.getDefaultCurrentContent(item.subMenu)
          if (childCurrentContent) {
            currentContent = childCurrentContent
          }
        }
      })
      return currentContent
    },
    getContent (menu, path, parent) {
      var content = {
        currentContent: null,
        detailContent: null,
        detailContentId: null
      }
      for (var i = 0; i < menu.length && content.currentContent === null; i++) {
        var menuUrl = menu[i].parentContextPath + menu[i].contextPath
        var menuUrlParams = menuUrl.split('/')
        var pathParams = path.split('/')

        var found = true
        var detailContentId = null
        if (menuUrlParams.length !== pathParams.length) {
          found = false
        } else {
          for (var j = 0; j < menuUrlParams.length && found; j++) {
            if (menuUrlParams[j] !== pathParams[j] && menuUrlParams[j].substr(0, 3) !== ':id') {
              found = false
            } else if (menuUrlParams[j].substr(0, 3) === ':id') {
              detailContentId = pathParams[j]
            }
          }
        }

        if (found) {
          // Detail content, load level 3 content as main level
          if (menuUrlParams.length > 4) {
            content.currentContent = parent
            content.detailContent = menu[i]
            content.detailContentId = detailContentId
          } else {
            content.currentContent = menu[i]
          }
        } else {
          if (content.currentContent === null && menu[i].subMenu) {
            var childContent = this.getContent(menu[i].subMenu, path, menu[i])
            if (childContent.currentContent) {
              content = childContent
            }
          }
        }
      }
      return content
    },
    getDefaultParentMenuPath (parent, menu, path) {
      var menuParent = null

      for (var i = 0; i < menu.length && menuParent === null; i++) {
        var menuUrl = menu[i].parentContextPath + menu[i].contextPath
        if (menuUrl === path) {
          menuParent = parent
        } else if (menu[i].subMenu) {
          menuParent = this.getDefaultParentMenuPath(menu[i], menu[i].subMenu, path)
        }
      }

      return menuParent
    },
    getMenuAppRoutes (menu) {
      var menuRoutes = null
      if (menu != null) {
        menuRoutes = []
        menu.map((item) => {
          var type = item.type

          if (type) {
            if (type.id === 'definition' || type.id === 'template' || type.id === 'workflow') {
              menuRoutes.push({
                path: item.contextPath,
                name: item.id,
                component: DefinitionLoader,
                props: item,
                children: this.getMenuAppRoutes(item.subMenu)
              })
            } else if (type.id === 'search') {
              menuRoutes.push({
                path: item.contextPath,
                name: item.id,
                component: Searcher,
                props: item,
                children: this.getMenuAppRoutes(item.subMenu)
              })
            } else if (type.id === 'content') {
              menuRoutes.push({
                path: item.contextPath,
                name: item.id,
                component: AppContent,
                props: item,
                children: this.getMenuAppRoutes(item.subMenu)
              })
            } else {
              menuRoutes.push({
                path: item.contextPath,
                name: item.id,
                component: Container,
                props: item,
                children: this.getMenuAppRoutes(item.subMenu)
              })
            }
          } else if (item.contextPath) {
            menuRoutes.push({
              path: item.contextPath,
              name: item.id,
              component: Container,
              props: item,
              children: this.getMenuAppRoutes(item.subMenu)
            })
          }
        })
      }
      return menuRoutes
    },
    loadDetailView (detailMenuId, detailIdValue, detailCodeValue) {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden'

      var pushObj = {
        name: detailMenuId,
        params: { id: detailIdValue }
      }
      if (detailCodeValue) {
        pushObj.query = { code: detailCodeValue }
      }
      router.push(pushObj).catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/menu.js